__webpack_require__.p = "https://store-loyaleat.signoramariola.mx/";